import { motion } from 'framer-motion';
import { css, styled } from 'styled-components';

interface ButtonContainerProps {
  $disabled?: boolean;
  $loading?: boolean;
  $color: 'primary' | 'secondary';
}
export const ButtonContainer = styled.button<ButtonContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  cursor: pointer;
  width: 100%;

  border-radius: var(--pcm-rounded-lg);
  font-weight: var(--pcm-button-font-weight);
  height: 47px;
  border: none;

  ${({ $color }) => {
    if ($color === 'primary') {
      return css`
        background: var(--pcm-primary-button-bankground);
        color: var(--pcm-primary-button-color);
        &:hover {
          background: var(--pcm-primary-button-hover-background);
        }
      `;
    } else if ($color === 'secondary') {
      return css`
        background: var(--pcm-secondary-button-bankground);
        color: var(--pcm-secondary-button-color);
        &:hover {
          background: var(--pcm-secondary-button-hover-background);
        }
      `;
    }
    return undefined;
  }}

  ${({ $disabled, $loading }) =>
    ($disabled || $loading) &&
    css`
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.5;
      div {
        opacity: 0.5;
      }
    `}

  &:hover {
    box-shadow: var(--pcm-button-hover-shadow);
  }
`;

export const InlineBox = styled.div`
  display: inline-block;
  margin-right: 8px;
`;

export const IconContainer = styled(motion.div)<{ $rounded?: boolean }>`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  max-width: 20px;
  max-height: 20px;
  margin: 0 10px;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
  ${(props) => {
    return (
      props.$rounded &&
      css`
        overflow: hidden;
        border-radius: var(--pcm-rounded-sm);
      `
    );
  }}
  svg {
    display: block;
    position: relative;
    max-width: 100%;
    height: auto;
  }
`;
